import React from 'react';
import FloatingImage from '../assests/AIicon.png';

const FloatingAIButton = ({ onClick }) => {
    return (
        <div style={{ position: 'fixed', bottom: '20px', right: '10px', zIndex: 1000 }}>
            <button onClick={onClick} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img src={FloatingImage} alt="AI Assistant" style={{ width: '80px', height: '80px', borderRadius: '50%' }} />
            </button>
        </div>
    );
};

export default FloatingAIButton;
